/* Liquid Image Ripple — FULL (fix per Welcome Page Shopify)
   ---------------------------------------------------------
   - Usa l’immagine fornita via Liquid: window.LIQUID_WELCOME_BG
   - Canvas con ID corretto (#liquid-bg-canvas) per applicare CSS
*/

const BACKGROUND_IMAGE_URL = window.LIQUID_WELCOME_BG;

(function () {
  /* CONFIG */
  let isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const CONFIG = {
    desktop: {
      DPR_CAP: 2,
      LENS_RADIUS: 220,
      LENS_STRENGTH: 40,
      LERP: 0.45,

      MAX_RIPPLES: 44,
      RIPPLE_START_RADIUS: 200,
      RIPPLE_EXPAND_PX_PER_S: 230,
      RIPPLE_DECAY_PER_S: 0.1,
      RIPPLE_STRENGTH: 160,
      RIPPLE_MIN_DIST: 14,
      RIPPLE_MIN_INTERVAL_MS: 12,
      RIPPLE_JITTER_PX: 36,
    },
    mobile: {
      DPR_CAP: 1.25,
      LENS_RADIUS: 1,
      LENS_STRENGTH: 4,
      LERP: 0.18,

      MAX_RIPPLES: 28,
      RIPPLE_START_RADIUS: 60,
      RIPPLE_EXPAND_PX_PER_S: 90,
      RIPPLE_DECAY_PER_S: 0.55,
      RIPPLE_STRENGTH: 90,
      RIPPLE_MIN_DIST: 36,
      RIPPLE_MIN_INTERVAL_MS: 14,
      RIPPLE_JITTER_PX: 40,
    },
  };

  let C = isTouch ? CONFIG.mobile : CONFIG.desktop;

  /* CREA CANVAS CON ID CORRETTO */
  const canvas = document.createElement("canvas");
  canvas.id = "liquid-bg-canvas";
  canvas.style.cssText =
    "position:fixed;inset:0;width:100vw;height:100vh;z-index:0;pointer-events:none;";
  document.body.appendChild(canvas);

  /* WebGL */
  const gl = canvas.getContext("webgl", {
    alpha: true,
    antialias: true,
    powerPreference: "high-performance",
  });

  if (!gl) {
    canvas.style.background =
      "radial-gradient(1200px circle at 20% 30%, #e9f00f 0%, #07a1bd 45%, #cb1656 100%)";
    console.error("WebGL non disponibile.");
    return;
  }

  /* SHADER */
  const MAX_R = Math.max(CONFIG.desktop.MAX_RIPPLES, CONFIG.mobile.MAX_RIPPLES);

  const vertSrc = `
    attribute vec2 a_pos;
    void main(){ gl_Position = vec4(a_pos, 0.0, 1.0); }
  `;

  const fragTpl = `
    precision highp float;
    const int MAX_RIPPLES = __MAX__;

    uniform vec2 u_res;
    uniform sampler2D u_tex;
    uniform vec2 u_texRes;
    uniform float u_hasTex;

    uniform vec2  u_cursor;
    uniform float u_lensRadius;
    uniform float u_lensStrength;

    uniform vec2  u_rPos[MAX_RIPPLES];
    uniform float u_rRad[MAX_RIPPLES];
    uniform float u_rLife[MAX_RIPPLES];
    uniform float u_rSeed[MAX_RIPPLES];
    uniform float u_rStrength;
    uniform float u_rJitterPx;

    float ring(float d, float r, float sigma){
      float x = (d - r) / max(1.0, sigma);
      return exp(-0.5 * x * x);
    }

    float hash(vec2 p){
      return fract(sin(dot(p, vec2(127.1,311.7))) * 43758.5453123);
    }

    float noise(vec2 p){
      vec2 i=floor(p), f=fract(p);
      float a=hash(i),
            b=hash(i+vec2(1.0,0.0)),
            c=hash(i+vec2(0.0,1.0)),
            d=hash(i+vec2(1.0,1.0));
      vec2 u=f*f*(3.0-2.0*f);
      return mix(a,b,u.x) +
             (c-a)*u.y*(1.0-u.x) +
             (d-b)*u.x*u.y;
    }

    float fbm(vec2 p){
      float v=0.0, s=0.5;
      for(int i=0; i<4; i++){
        v += s * noise(p);
        p *= 2.02;
        s *= 0.5;
      }
      return v;
    }

    vec2 coverUV(vec2 uv, vec2 cRes, vec2 iRes){
      float cr = cRes.x / cRes.y;
      float ir = iRes.x / iRes.y;
      vec2 scale = (ir > cr) ? vec2(cr/ir, 1.0) : vec2(1.0, ir/cr);
      return (uv - 0.5) * scale + 0.5;
    }

    void main(){
      vec2 fragPx = gl_FragCoord.xy;
      vec2 uv = fragPx / u_res;

      vec2 offset = vec2(0.0);

      {
        vec2 d = fragPx - u_cursor;
        float dist = length(d);
        float w = ring(dist, u_lensRadius, u_lensRadius * 0.5);
        if (dist > 0.0)
          offset += (u_lensStrength * w) * (d / dist) / u_res;
      }

      for (int i=0; i<MAX_RIPPLES; i++){
        float life = u_rLife[i];
        float rad  = u_rRad[i];
        if (life <= 0.0 || rad <= 0.0)
          continue;

        vec2 rp = u_rPos[i];
        vec2 d  = fragPx - rp;

        float dist = length(d);
        float jitterPx = (fbm((d + u_rSeed[i]) * 0.02) - 0.5) * 2.0 * u_rJitterPx;

        float sigma = rad * 0.22;
        float w = ring(max(0.0, dist + jitterPx), rad, sigma) * life;

        if (dist > 0.0)
          offset += (u_rStrength * w) * (d / dist) / u_res;
      }

      vec2 uv2 = uv - offset;
      vec3 col;

      if (u_hasTex > 0.5) {
        vec2 tuv = coverUV(uv2, u_res, u_texRes);
        col = texture2D(u_tex, tuv).rgb;
      } else {
        col = vec3(0.2, 0.2, 0.2);
      }

      gl_FragColor = vec4(col, 1.0);
    }
  `;

  const fragSrc = fragTpl.replace("__MAX__", String(MAX_R));

  function compile(type, src) {
    const s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);

    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
      console.error(gl.getShaderInfoLog(s));
    }

    return s;
  }

  const vs = compile(gl.VERTEX_SHADER, vertSrc);
  const fs = compile(gl.FRAGMENT_SHADER, fragSrc);

  const prog = gl.createProgram();
  gl.attachShader(prog, vs);
  gl.attachShader(prog, fs);
  gl.linkProgram(prog);

  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) {
    console.error(gl.getProgramInfoLog(prog));
  }

  gl.useProgram(prog);

  /* FULLSCREEN QUAD */
  const buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(
    gl.ARRAY_BUFFER,
    new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
    gl.STATIC_DRAW
  );

  const aPos = gl.getAttribLocation(prog, "a_pos");
  gl.enableVertexAttribArray(aPos);
  gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);

  /* UNIFORMS */
  const uRes = gl.getUniformLocation(prog, "u_res");
  const uTex = gl.getUniformLocation(prog, "u_tex");
  const uTexRes = gl.getUniformLocation(prog, "u_texRes");
  const uHasTex = gl.getUniformLocation(prog, "u_hasTex");

  const uCursor = gl.getUniformLocation(prog, "u_cursor");
  const uLensRad = gl.getUniformLocation(prog, "u_lensRadius");
  const uLensStr = gl.getUniformLocation(prog, "u_lensStrength");

  const uRPos = Array.from({ length: MAX_R }, (_, i) =>
    gl.getUniformLocation(prog, `u_rPos[${i}]`)
  );
  const uRRad = Array.from({ length: MAX_R }, (_, i) =>
    gl.getUniformLocation(prog, `u_rRad[${i}]`)
  );
  const uRLife = Array.from({ length: MAX_R }, (_, i) =>
    gl.getUniformLocation(prog, `u_rLife[${i}]`)
  );
  const uRSeed = Array.from({ length: MAX_R }, (_, i) =>
    gl.getUniformLocation(prog, `u_rSeed[${i}]`)
  );
  const uRStr = gl.getUniformLocation(prog, "u_rStrength");
  const uRJit = gl.getUniformLocation(prog, "u_rJitterPx");

  gl.uniform1i(uTex, 0);

  /* STATE */
  let dpr = 1;
  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, C.DPR_CAP);
    const w = Math.floor(innerWidth * dpr),
      h = Math.floor(innerHeight * dpr);

    if (canvas.width !== w || canvas.height !== h) {
      canvas.width = w;
      canvas.height = h;
      gl.viewport(0, 0, w, h);
      gl.uniform2f(uRes, w, h);
    }
  }

  resize();
  addEventListener("resize", resize, { passive: true });

  let cur = { x: innerWidth / 2, y: innerHeight / 2 };
  let vis = { x: cur.x, y: cur.y };

  addEventListener(
    "pointermove",
    (e) => {
      cur.x = e.clientX;
      cur.y = e.clientY;
    },
    { passive: true }
  );

  addEventListener(
    "pointerdown",
    (e) => {
      cur.x = e.clientX;
      cur.y = e.clientY;
      spawnMaybe(cur.x, cur.y);
    },
    { passive: true }
  );

  document.addEventListener(
    "touchmove",
    (e) => {
      const t = e.touches && e.touches[0];
      if (!t) return;
      cur.x = t.clientX;
      cur.y = t.clientY;
      spawnMaybe(cur.x, cur.y);
    },
    { passive: true }
  );

  document.addEventListener(
    "touchstart",
    (e) => {
      const t = e.touches && e.touches[0];
      if (!t) return;
      cur.x = t.clientX;
      cur.y = t.clientY;
      spawnRipple(cur.x, cur.y);
    },
    { passive: true }
  );

  let lastScrollY = window.scrollY || 0;

  addEventListener(
    "scroll",
    () => {
      if (!isTouch) return;
      const y = window.scrollY || 0;
      const dy = y - lastScrollY;
      lastScrollY = y;

      const x = innerWidth * 0.5;
      const yPos = dy > 0 ? innerHeight * 0.4 : innerHeight * 0.6;

      cur.x = x;
      cur.y = yPos;
      spawnMaybe(x, yPos);
    },
    { passive: true }
  );

  function applyMode(e) {
    const nowTouch = e && e.pointerType ? e.pointerType !== "mouse" : isTouch;
    if (nowTouch !== isTouch) {
      isTouch = nowTouch;
      C = isTouch ? CONFIG.mobile : CONFIG.desktop;
      resize();
    }
  }

  addEventListener("pointerdown", applyMode, { passive: true });
  addEventListener("pointermove", applyMode, { passive: true });

  const ripples = Array.from({ length: MAX_R }, () => ({
    x: 0,
    y: 0,
    rad: 0,
    life: 0,
    seed: 0,
  }));

  function rnd(min, max) {
    return min + Math.random() * (max - min);
  }

  let lastX = -1,
    lastY = -1,
    lastTs = 0;

  function spawnRipple(x, y) {
    let idx = -1,
      minLife = Infinity;

    for (let i = 0; i < MAX_R; i++) {
      if (ripples[i].life <= 0) {
        idx = i;
        break;
      }
      if (ripples[i].life < minLife) {
        minLife = ripples[i].life;
        idx = i;
      }
    }

    ripples[idx].x = x;
    ripples[idx].y = y;
    ripples[idx].rad = C.RIPPLE_START_RADIUS;
    ripples[idx].life = 1.0;
    ripples[idx].seed = rnd(0.0, 1000.0);
  }

  function spawnMaybe(x, y) {
    const now = performance.now();

    if (now - lastTs < C.RIPPLE_MIN_INTERVAL_MS) return;

    if (lastX >= 0) {
      const dx = x - lastX,
        dy = y - lastY;
      if (Math.hypot(dx, dy) < C.RIPPLE_MIN_DIST) return;
    }

    spawnRipple(x, y);
    lastX = x;
    lastY = y;
    lastTs = now;
  }

  /* TEXTURE */
  const img = new Image();
  img.crossOrigin = "anonymous";

  let tex = null,
    texW = 1,
    texH = 1,
    hasTex = 0;

  img.onload = () => {
    texW = img.naturalWidth || img.width;
    texH = img.naturalHeight || img.height;

    tex = gl.createTexture();
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, tex);

    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    gl.texImage2D(
      gl.TEXTURE_2D,
      0,
      gl.RGBA,
      gl.RGBA,
      gl.UNSIGNED_BYTE,
      img
    );

    hasTex = 1;
  };

  img.onerror = () => {
    hasTex = 0;
    console.error("Errore caricamento immagine:", BACKGROUND_IMAGE_URL);
  };

  console.log("Carico BG:", BACKGROUND_IMAGE_URL);
  img.src = BACKGROUND_IMAGE_URL;

  /* ANIMAZIONE */
  const uUniforms = {
    uploadStatics() {
      gl.uniform1f(uRStr, C.RIPPLE_STRENGTH);
      gl.uniform1f(uRJit, C.RIPPLE_JITTER_PX);
      gl.uniform1f(uLensRad, C.LENS_RADIUS);
      gl.uniform1f(uLensStr, C.LENS_STRENGTH);
    },

    uploadDynamics() {
      const cx = vis.x * dpr;
      const cy = (canvas.height / dpr - vis.y) * dpr;

      gl.uniform2f(uCursor, cx, cy);

      gl.uniform1f(uRStr, C.RIPPLE_STRENGTH);
      gl.uniform1f(uRJit, C.RIPPLE_JITTER_PX);
      gl.uniform1f(uLensRad, C.LENS_RADIUS);
      gl.uniform1f(uLensStr, C.LENS_STRENGTH);

      gl.uniform2f(uTexRes, texW, texH);
      gl.uniform1f(uHasTex, hasTex);

      for (let i = 0; i < MAX_R; i++) {
        const r = ripples[i];
        const alive = r.life > 0;

        const x = alive ? r.x * dpr : 0;
        const y = alive
          ? (canvas.height / dpr - r.y) * dpr
          : 0;

        gl.uniform2f(uRPos[i], x, y);
        gl.uniform1f(uRRad[i], alive ? r.rad : 0);
        gl.uniform1f(uRLife[i], alive ? r.life : 0);
        gl.uniform1f(uRSeed[i], alive ? r.seed : 0);
      }
    },
  };

  let lastT = 0;

  function frame(ts) {
    if (!lastT) lastT = ts;
    const dt = Math.min((ts - lastT) / 1000, 0.1);
    lastT = ts;

    vis.x += (cur.x - vis.x) * C.LERP;
    vis.y += (cur.y - vis.y) * C.LERP;

    for (let i = 0; i < MAX_R; i++) {
      const r = ripples[i];
      if (r.life > 0) {
        r.rad += C.RIPPLE_EXPAND_PX_PER_S * dt;
        r.life -= C.RIPPLE_DECAY_PER_S * dt;
        if (r.life < 0) r.life = 0;
        if (r.rad > Math.max(innerWidth, innerHeight) * 2) r.life = 0;
      }
    }

    uUniforms.uploadDynamics();

    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLES, 0, 6);

    requestAnimationFrame(frame);
  }

  gl.uniform1i(uTex, 0);
  uUniforms.uploadStatics();
  resize();
  requestAnimationFrame(frame);
})();
